import { render, staticRenderFns } from "./CollectionLayout.vue?vue&type=template&id=04c1c7f4&"
import script from "./CollectionLayout.vue?vue&type=script&lang=js&"
export * from "./CollectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports